import Comment from "./core/Comment";


if (document.getElementById('commentary')) {
    new Comment(false);
}


